import { render } from "./helpdesk-chatbot.vue?vue&type=template&id=ee11ae48&scoped=true"
import script from "./helpdesk-chatbot.vue?vue&type=script&lang=js"
export * from "./helpdesk-chatbot.vue?vue&type=script&lang=js"

import "./helpdesk-chatbot.vue?vue&type=style&index=0&id=ee11ae48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee11ae48"]])

export default __exports__